export default __webpack_public_path__ + "static/media/qblogo.2bb29746.png";